// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f9d283d7","473":"316ceda4","607":"95721a74"}[chunkId] + ".chunk.js";
};